module.exports = __webpack_public_path__ + "img/BoglarkaPeter.24088c1.png";